import React from 'react'
import { Field } from 'redux-form'

export default () => (
  <div className="equote-package-additional-details-form--loyalty">
    <div className="equote-package-additional-details-form--input-group">
      <div className='equote-package-additional-details-form--input-group--container'>
        <label className="equote-package-additional-details-form--input-group--label">
          LOYALTY PROGRAM
        </label>
        <div className="equote-package-additional-details-form--input-group--field">
          <Field
            name="Loyalty"
            component="input"
            className="equote-package-additional-details-form--textInput"
            placeholder="Enter Loyalty ID"
          />
        </div>
      </div>
      
    </div>
  </div>
)
